import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { BadgeProvider } from './components/BadgeContext';
import { SpinnerProvider } from './components/SpinnerContext';
import './i18n';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <SpinnerProvider>
        <BadgeProvider>
          <App />
        </BadgeProvider>
      </SpinnerProvider>
    </Provider>
  </React.StrictMode>
),

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
